<template>
  <div class="widget-field-attachment-list">
    <div
      v-for="attachment in attachments"
      :key="attachment.id"
    >
      <widget-field-uploading-attachment
        v-if="isWidgetUploadingAttachment(attachment)"
        :mime-type="attachment.mimeType"
        :name="attachment.name"
        :size="attachment.size"
        :upload-progress="attachment.uploadProgress"
        :preview-url="attachment.previewUrl"
        :error="attachment.error"
        @remove="$emit('remove-attachment', attachment.id)"
        @retry="$emit('retry-attachment', attachment.id)"
      />
      <widget-field-uploaded-attachment
        v-else-if="isWidgetUploadedAttachment(attachment)"
        :mime-type="attachment.mimeType"
        :name="attachment.name"
        :size="attachment.size"
        :download-url="attachment.downloadUrl"
        :preview-url="attachment.previewUrl"
        @remove="$emit('remove-attachment', attachment.id)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { isWidgetUploadedAttachment, isWidgetUploadingAttachment, type WidgetAttachment } from '@widgets/shared/types'
import WidgetFieldUploadedAttachment from '@widgets/shared/components/attachment/field/WidgetFieldUploadedAttachment.vue'
import WidgetFieldUploadingAttachment from '@widgets/shared/components/attachment/field/WidgetFieldUploadingAttachment.vue'

const { attachments } = defineProps<{
  attachments: WidgetAttachment[]
}>()

defineEmits<{
  (e: 'remove-attachment', attachmentId: string): void
  (e: 'retry-attachment', attachmentId: string): void
}>()
</script>

<style lang="scss" scoped>
.widget-field-attachment-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
</style>
